var _style, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgDisabled = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "dissable",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n    .disabled-color{fill:#ED1E5C;}\n    .disabled-st1{fill:#FFFFFF;}\n  ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "crossedline",
    className: "disabled-color",
    d: "M158.7,382.2c-2.8,0-5.5-1-7.7-3.1c-4.3-4.2-4.4-11.2-0.2-15.5l209.7-215.4   c4.2-4.3,11.2-4.4,15.5-0.2c4.3,4.2,4.4,11.2,0.2,15.5L166.6,378.9C164.4,381.1,161.6,382.2,158.7,382.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "solidline",
    className: "disabled-st1",
    d: "M143.6,367.1c-2.8,0-5.5-1-7.7-3.1c-4.3-4.2-4.4-11.2-0.2-15.5l209.7-215.4   c4.2-4.3,11.2-4.4,15.5-0.2c4.3,4.2,4.4,11.2,0.2,15.5L151.5,363.8C149.3,366,146.5,367.1,143.6,367.1z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDisabled, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/disabled.fe4a7468.svg";
export { ForwardRef as ReactComponent };